import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import SEO from "../seo";
import { slugify } from "../../utils/slugify";

const QuickLaunchChecklist = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const navigate = useNavigate();

  // Icon mapping function based on section title
  const getSectionIcon = (title) => {
    const iconMap = {
      "Set Up Your Brand": (
        <svg
          width="40"
          height="40"
          viewBox="0 0 53 53"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M26.5 48.5833C38.6962 48.5833 48.5833 38.6962 48.5833 26.5C48.5833 14.3037 38.6962 4.41663 26.5 4.41663C14.3037 4.41663 4.41663 14.3037 4.41663 26.5C4.41663 38.6962 14.3037 48.5833 26.5 48.5833Z"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M26.5 17.6666V26.5L31.9375 31.9375"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M17.6666 26.5H35.3333"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
      "Generate Your Landing Page": (
        <svg
          width="40"
          height="40"
          viewBox="0 0 53 53"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M39.75 13.25H13.25C8.38163 13.25 4.41663 17.215 4.41663 22.0833V39.75C4.41663 44.6184 8.38163 48.5833 13.25 48.5833H39.75C44.6184 48.5833 48.5833 44.6184 48.5833 39.75V22.0833C48.5833 17.215 44.6184 13.25 39.75 13.25Z"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M19.875 13.25V9.9375C19.875 7.40167 21.9017 5.375 24.4375 5.375H28.5625C31.0983 5.375 33.125 7.40167 33.125 9.9375V13.25"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M19.875 23.1875H33.125"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M19.875 30.9166H33.125"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M26.5 35.3333C29.8135 35.3333 32.5 32.6468 32.5 29.3333C32.5 26.0198 29.8135 23.3333 26.5 23.3333C23.1865 23.3333 20.5 26.0198 20.5 29.3333C20.5 32.6468 23.1865 35.3333 26.5 35.3333Z"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
      "Set Up Your Domain": (
        <svg
          width="40"
          height="40"
          viewBox="0 0 53 53"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M26.5 48.5833C38.6962 48.5833 48.5833 38.6962 48.5833 26.5C48.5833 14.3037 38.6962 4.41663 26.5 4.41663C14.3037 4.41663 4.41663 14.3037 4.41663 26.5C4.41663 38.6962 14.3037 48.5833 26.5 48.5833Z"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M4.41663 26.5H48.5833"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M26.5 4.41663C32.2291 9.26083 35.3333 17.4796 35.3333 26.5C35.3333 35.5204 32.2291 43.7392 26.5 48.5833C20.7708 43.7392 17.6666 35.5204 17.6666 26.5C17.6666 17.4796 20.7708 9.26083 26.5 4.41663Z"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
      "Set Up Your Payments": (
        <svg
          width="40"
          height="40"
          viewBox="0 0 53 53"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M39.75 17.6666H13.25C8.38163 17.6666 4.41663 21.6316 4.41663 26.5V39.75C4.41663 44.6184 8.38163 48.5833 13.25 48.5833H39.75C44.6184 48.5833 48.5833 44.6184 48.5833 39.75V26.5C48.5833 21.6316 44.6184 17.6666 39.75 17.6666Z"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M4.41663 22.0833H48.5833"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M33.125 35.3333C35.1012 35.3333 36.7083 33.7262 36.7083 31.75C36.7083 29.7738 35.1012 28.1666 33.125 28.1666C31.1488 28.1666 29.5416 29.7738 29.5416 31.75C29.5416 33.7262 31.1488 35.3333 33.125 35.3333Z"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
      "Review Shipping & Policies": (
        <svg
          width="40"
          height="40"
          viewBox="0 0 53 53"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M39.75 17.6666H13.25C8.38163 17.6666 4.41663 21.6316 4.41663 26.5V39.75C4.41663 44.6184 8.38163 48.5833 13.25 48.5833H39.75C44.6184 48.5833 48.5833 44.6184 48.5833 39.75V26.5C48.5833 21.6316 44.6184 17.6666 39.75 17.6666Z"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M17.6666 17.6666V13.25C17.6666 9.00996 21.0933 5.58329 25.3333 5.58329H27.6666C31.9066 5.58329 35.3333 9.00996 35.3333 13.25V17.6666"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M19.875 26.5H33.125"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M19.875 33.125H28.7083"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M19.875 39.75H26.5"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
    };

    return (
      iconMap[title] || (
        <svg
          width="40"
          height="40"
          viewBox="0 0 53 53"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M26.5 48.5833C38.6962 48.5833 48.5833 38.6962 48.5833 26.5C48.5833 14.3037 38.6962 4.41663 26.5 4.41663C14.3037 4.41663 4.41663 14.3037 4.41663 26.5C4.41663 38.6962 14.3037 48.5833 26.5 48.5833Z"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M26.5 17.6666V26.5L31.9375 31.9375"
            stroke="#5F3164"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )
    );
  };

  const helpSections = [
    {
      title: "Store Setup",
      description: "Configure and launch your xPAGE store",
      items: [
        {
          id: "quick-launch-checklist",
          title: "Quick Launch Checklist",
          description: "Essential steps to quickly launch your xPAGE store.",
          icon: (
            <svg
              width="40"
              height="40"
              viewBox="0 0 53 53"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M7.72913 39.75V15.4583C7.72913 6.62496 9.93746 4.41663 18.7708 4.41663H34.2291C43.0625 4.41663 45.2708 6.62496 45.2708 15.4583V37.5416C45.2708 37.8508 45.2708 38.16 45.2487 38.4691"
                stroke="#5F3164"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M14.0229 33.125H45.2708V40.8542C45.2708 45.1162 41.8037 48.5833 37.5416 48.5833H15.4583C11.1962 48.5833 7.72913 45.1162 7.72913 40.8542V39.4188C7.72913 35.9517 10.5558 33.125 14.0229 33.125Z"
                stroke="#5F3164"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M17.6666 15.4584H35.3333"
                stroke="#5F3164"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M17.6666 23.1875H28.7083"
                stroke="#5F3164"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          ),
          sections: [
            {
              id: "Set Up Your Brand",
              title: "Set Up Your Brand",
              description:
                "Configure your brand identity including logo, colors, and business information.",
            },
            {
              id: "Generate Your Landing Page",
              title: "Generate Your Landing Page",
              description:
                "Use AI builder to create and customize your landing page design instantly.",
            },
            {
              id: "Set Up Your Domain",
              title: "Set Up Your Domain",
              description:
                "Connect your custom domain for a professional branded experience.",
            },
            {
              id: "Set Up Your Payments",
              title: "Set Up Your Payments",
              description:
                "Configure payment methods including card, COD, and other gateway options.",
            },
            {
              id: "Review Shipping & Policies",
              title: "Review Shipping & Policies",
              description:
                "Set up shipping options, return policies, and terms of service.",
            },
          ],
        },
      ],
    },
  ];

  // Handle card click - use the exact section names from sidebar
  // Handle card click - update URL with section like sidebar (no slugs)
  const handleCardClick = (itemId, sectionId) => {
  navigate(`/help/${slugify(itemId)}/${slugify(sectionId)}`);
};


  // Filter items based on search query
  const filteredSections = helpSections
    .map((section) => ({
      ...section,
      items: section.items.filter(
        (item) =>
          item.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
          item.description.toLowerCase().includes(searchQuery.toLowerCase()) ||
          section.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
          item.sections.some(
            (sectionItem) =>
              sectionItem.title
                .toLowerCase()
                .includes(searchQuery.toLowerCase()) ||
              sectionItem.description
                .toLowerCase()
                .includes(searchQuery.toLowerCase()),
          ),
      ),
    }))
    .filter((section) => section.items.length > 0);

  return (
    <div className="min-h-screen flex flex-col md:pt-10 pt-16">
      <SEO
        title="Quick Launch Checklist – Launch Your xPAGE Store"
        description="Step-by-step Quick Launch Guide to set up your xPAGE store: brand, landing page, domain, payments, shipping, and policies."
        keywords="xPAGE, Quick Launch Guide, eCommerce setup, landing page, domain setup, payments setup, shipping policies"
        canonical="https://help.xpage.ai/help/quick-launch-checklist/quick-launch-checklist"
        type="article"
      />
      <div className="flex-1 w-full py-6 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          {/* Header with Description */}
          <div className="mb-6">
            <h1 className="text-2xl font-semibold text-systemTitle mb-3">
              Quick Launch Guide
            </h1>

            {/* Added description text */}
            <div className="mb-6">
              <p className="text-sm text-systemSubTitle leading-relaxed">
                Launch your online landing page in just a few minutes. Start by
                creating your account and connecting your custom domain for a
                branded experience. Add your products via link, image and prompt
                or manually, then use the AI builder to design and publish your
                landing page instantly. Set up your payment methods — whether
                card, COD, or other gateways — and run a quick checkout test to
                ensure everything works smoothly. Once ready, go live and start
                tracking your sales and visitors in real time.
              </p>
            </div>
          </div>

          {/* Spacing between description and cards */}
          <div className="mb-6"></div>

          {/* Help Sections */}
          <div className="space-y-6">
            {filteredSections.map((section, sectionIndex) => (
              <div className="p-4">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                  {section.items.flatMap((item) =>
                    item.sections.map((sectionItem, sectionIndex) => (
                      <div
                        key={sectionIndex}
                        onClick={() => handleCardClick(item.id, sectionItem.id)}
                        className="group relative bg-white border border-gray-200 rounded-xl p-4 hover:shadow-lg transition-all duration-300 ease-in-out transform hover:-translate-y-1 cursor-pointer hover:border-systemLabel"
                      >
                        {/* Hover effect background */}

                        <div className="relative z-10">
                          {/* Icon and Title */}
                          <div className="flex items-center space-x-3 mb-3">
                            <div className="flex-shrink-0 w-10 h-10 bg-gray-100 rounded-lg flex items-center justify-center transition-colors duration-300 group-hover:bg-deepPurple/5">
                              {getSectionIcon(sectionItem.title)}
                            </div>
                            <h3 className="text-lg font-semibold text-systemTitle transition duration-300">
                              {sectionItem.title}
                            </h3>
                          </div>

                          {/* Section-specific description */}
                          <p className="text-sm text-systemLabel leading-relaxed transition-colors duration-300">
                            {sectionItem.description}
                          </p>

                          {/* Hover arrow indicator */}

                          <div className="absolute right-4 top-4 opacity-0 group-hover:opacity-100 transform translate-x-2 group-hover:translate-x-0 transition-all duration-300">
                            <svg
                              className="w-7 h-7 text-base"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M9 5l7 7-7 7"
                              />
                            </svg>
                          </div>
                        </div>
                      </div>
                    )),
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuickLaunchChecklist;
